import { classNames, normalizePxSize, setCssVar } from "@punks/ui-core";
import { ShapeRounding } from "../types/rounding";

export const getRounding = (rounding?: ShapeRounding) => {
    return {
        styles: {
            ...(rounding?.type === "custom" && { ...setCssVar("--cr", normalizePxSize(rounding.customValue)) }),
        } satisfies React.CSSProperties,
        classes: classNames({
            "rounded-sm": rounding?.type === "sm",
            "rounded-md": rounding?.type === "md",
            "rounded-lg": rounding?.type === "lg",
            "rounded-[var(--cr)]": rounding?.type === "custom",
        }) satisfies string,
    }
}
